/**
 * Israeli new shekel.
 */
export var ILS = {
  code: 'ILS',
  base: 10,
  exponent: 2
};